import React from 'react';
import { FaMicrophoneSlash, FaMicrophone, FaTimes } from 'react-icons/fa';
import './ParticipantPanel.css';

const avatarColor = (identity) => {
    let hash = 0;
    for (let i = 0; i < identity.length; i++) hash = identity.charCodeAt(i) + ((hash << 5) - hash);
    const colors = ['#667eea', '#ed8936', '#48bb78', '#e53e3e', '#38b2ac', '#9f7aea', '#f6ad55'];
    return colors[Math.abs(hash) % colors.length];
};

const ParticipantPanel = ({ participants, localIdentity, isHost, onMuteRequest, onClose }) => (
    <div className="participant-panel">
        <div className="participant-panel-header">
            <span>{participants.length} Participant{participants.length !== 1 ? 's' : ''}</span>
            <button className="participant-panel-close" onClick={onClose}>
                <FaTimes size={12} />
            </button>
        </div>

        <div className="participant-panel-list">
            {participants.map((p) => (
                <div key={p.identity} className={`participant-row ${p.isSpeaking ? 'speaking' : ''}`}>
                    <div
                        className="participant-avatar"
                        style={{ background: avatarColor(p.identity) }}
                    >
                        {(p.name || p.identity).charAt(0).toUpperCase()}
                    </div>

                    <div className="participant-info">
                        <div className="participant-name">
                            {p.name || p.identity}
                            {p.identity === localIdentity && <span className="you-label"> (You)</span>}
                        </div>
                        <div className={`role-badge role-${p.role}`}>{p.role}</div>
                    </div>

                    <div className="participant-actions">
                        <span className={`mic-icon ${p.isMuted ? 'muted' : ''}`}>
                            {p.isMuted ? <FaMicrophoneSlash size={12} /> : <FaMicrophone size={12} />}
                        </span>

                        {isHost && p.identity !== localIdentity && !p.isMuted && (
                            <button
                                className="mute-btn"
                                onClick={() => onMuteRequest(p.identity)}
                                title="Request mute"
                            >
                                Mute
                            </button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default ParticipantPanel;
